import * as React from 'react'
import { osName } from 'react-device-detect'
import { IWPGBlock } from 'react-gutenberg'

import { IAttributes } from 'app/components/CustomBlocks/layout/HeroLayoutBlock/Attributes'
import HeroLayoutComponent from 'app/components/CustomBlocks/layout/HeroLayoutBlock/HeroLayoutComponent'
import { ReactBlocks } from 'app/helpers/Blocks'

const HeroLayoutBlock: React.FC<IWPGBlock> = (props) => {
  const [os, setOs] = React.useState<string>('')
  const attributes = props.attrs as IAttributes

  React.useEffect(() => {
    setOs(osName.toLowerCase())
  })

  return <HeroLayoutComponent os={os} {...attributes} innerBlocks={<ReactBlocks innerBlocks={props.innerBlocks} />} />
}

export default HeroLayoutBlock
